import Link from '@mui/material/Link';
import { merge } from 'lodash';
import { FC } from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom';
import { Theme } from '../../../theme';
import { SxProps } from '../../../common/system/SxProps';

type Props = {
  disabled?: boolean;
  asLink?: boolean;
} & LinkProps;

export const RouterLink: FC<Props> = ({ children, style, disabled, asLink, ...props }) => {
  const styles: SxProps<Theme> = merge(
    {
      textDecoration: 'none',
      cursor: disabled ? 'auto' : 'pointer',
      '&:hover': { textDecoration: asLink ? 'underline' : undefined },
      '&.Mui-focusVisible': {
        outline: 'auto',
      },
    },
    style,
  );
  return (
    <Link component={ReactRouterLink} sx={styles} {...props}>
      {children}
    </Link>
  );
};
